import { render, staticRenderFns } from "./SessionError.vue?vue&type=template&id=078ff1c3"
import script from "./SessionError.vue?vue&type=script&lang=js"
export * from "./SessionError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports